module.exports = __webpack_public_path__ + "static/media/video.5931b3fb.png";